export const PACKAGES_NOT_FOUND_ERROR = new Error('Packages entity not found');
